"use strict";

exports.__esModule = true;
exports.PIPE_TYPE = void 0;
exports.createPipe = createPipe;
exports.pipe = pipe;
var _factory = _interopRequireDefault(require("./factory.js"));
var _holder = _interopRequireDefault(require("../core/holder.js"));
require("../core/utils.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Mask pipe source and destination types */
var PIPE_TYPE = exports.PIPE_TYPE = {
  MASKED: 'value',
  UNMASKED: 'unmaskedValue',
  TYPED: 'typedValue'
};
/** Creates new pipe function depending on mask type, source and destination options */
function createPipe(arg, from, to) {
  if (from === void 0) {
    from = PIPE_TYPE.MASKED;
  }
  if (to === void 0) {
    to = PIPE_TYPE.MASKED;
  }
  var masked = (0, _factory.default)(arg);
  return function (value) {
    return masked.runIsolated(function (m) {
      m[from] = value;
      return m[to];
    });
  };
}

/** Pipes value through mask depending on mask type, source and destination options */
function pipe(value, mask, from, to) {
  return createPipe(mask, from, to)(value);
}
_holder.default.PIPE_TYPE = PIPE_TYPE;
_holder.default.createPipe = createPipe;
_holder.default.pipe = pipe;